module.exports = __webpack_public_path__ + "img/乌梅.6d1b3cb1.jpg";